/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import BrandCreate from '../model/BrandCreate';
import BrandList from '../model/BrandList';
import BrandListMetricsRead from '../model/BrandListMetricsRead';
import BrandMetricsRead from '../model/BrandMetricsRead';
import BrandRead from '../model/BrandRead';
import BrandState from '../model/BrandState';
import BrandStateUpdate from '../model/BrandStateUpdate';
import BrandUpdate from '../model/BrandUpdate';
import BrandVersionList from '../model/BrandVersionList';
import BrandVersionRead from '../model/BrandVersionRead';
import BrandVersionWrite from '../model/BrandVersionWrite';
import ForbiddenError from '../model/ForbiddenError';
import InlineObject4 from '../model/InlineObject4';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import UnauthorizedError from '../model/UnauthorizedError';

/**
* Brand service.
* @module api/BrandApi
* @version 1.7.2
*/
export default class BrandApi {

    /**
    * Constructs a new BrandApi. 
    * @alias module:api/BrandApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createBrand operation.
     * @callback module:api/BrandApi~createBrandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {module:model/BrandCreate} brand Required properties are: * name  Rich-text properties are: * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/BrandApi~createBrandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandRead}
     */
    createBrand(acceptLanguage, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createBrand");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling createBrand");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandRead;
      return this.apiClient.callApi(
        '/brands', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createBrandVersion operation.
     * @callback module:api/BrandApi~createBrandVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Brand resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} brandId 
     * @param {module:model/BrandVersionWrite} brand Required properties are: * name  Rich-text properties are: * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/BrandApi~createBrandVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    createBrandVersion(acceptLanguage, brandId, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createBrandVersion");
      }
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling createBrandVersion");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling createBrandVersion");
      }

      let pathParams = {
        'brand_id': brandId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteBrand operation.
     * @callback module:api/BrandApi~deleteBrandCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Brand resource.
     * @param {String} id 
     * @param {module:api/BrandApi~deleteBrandCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteBrand(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteBrand");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/brands/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrand operation.
     * @callback module:api/BrandApi~getBrandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/BrandApi~getBrandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandRead}
     */
    getBrand(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getBrand");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrand");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandRead;
      return this.apiClient.callApi(
        '/brands/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandList operation.
     * @callback module:api/BrandApi~getBrandListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BrandList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Brand resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **origin** (text) * **created_at** (datetime) * **name** (text) * **slug** (text) * **slug__keyword** (text, exact match) * **description** (text) * **claim** (text) * **statement** (text) * **lead** (text) * **content** (text) * **state** (text)  Supported order-by fields are:  * created_at * updated_at * name  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` name:something;created_at:>=2000-01-01T00:00:00Z ```  Search by origin identifier: ``` origin:B-0123 ```  Search where date between two values, order by name (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@name:ASC ```  Search by numeric extended attribute (always prefixed with *attr_*), having a value greater than: ``` attr_number_of_likes:>10 ```   Search by taxonomy taxon, global scope: ``` taxonomy_tags:09c73060-2aed-11e9-b210-d663bd873d93 ```  Search by sitemap node, client scope: ``` sitemap_client_tags:09c73060-2aed-11e9-b210-d663bd873d93 ```  Search by taxonomy taxon's owner, user scope: ``` taxonomy_user_tags_owned_by:acf824e0-e849-11ea-adc1-0242ac120002 ```  The search key for content taxons is always prefixed with *taxonomy_* or *sitemap_*, followed by the scope (*client*, *client_user*, or *user*; scope is omitted for *global* scope), then the bag name. If the search is by taxon's owner, then the additional *_owned_by* is appended. 
     * @param {Number} opts.page The list page number
     * @param {module:api/BrandApi~getBrandListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BrandList>}
     */
    getBrandList(acceptLanguage, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getBrandList");
      }

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [BrandList];
      return this.apiClient.callApi(
        '/brands', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandListMetrics operation.
     * @callback module:api/BrandApi~getBrandListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a BrandListMetrics resource.
     * @param {module:api/BrandApi~getBrandListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandListMetricsRead}
     */
    getBrandListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandListMetricsRead;
      return this.apiClient.callApi(
        '/brands/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandMetrics operation.
     * @callback module:api/BrandApi~getBrandMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a BrandMetrics resource.
     * @param {String} id 
     * @param {module:api/BrandApi~getBrandMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandMetricsRead}
     */
    getBrandMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrandMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandMetricsRead;
      return this.apiClient.callApi(
        '/brands/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandState operation.
     * @callback module:api/BrandApi~getBrandStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/BrandApi~getBrandStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandState}
     */
    getBrandState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getBrandState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrandState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandState;
      return this.apiClient.callApi(
        '/brands/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandVersion operation.
     * @callback module:api/BrandApi~getBrandVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Brand resource version.
     * @param {String} brandId 
     * @param {String} id 
     * @param {module:api/BrandApi~getBrandVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    getBrandVersion(brandId, id, callback) {
      let postBody = null;
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling getBrandVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrandVersion");
      }

      let pathParams = {
        'brand_id': brandId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandVersionList operation.
     * @callback module:api/BrandApi~getBrandVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BrandVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Brand versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} brandId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/BrandApi~getBrandVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BrandVersionList>}
     */
    getBrandVersionList(acceptLanguage, brandId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getBrandVersionList");
      }
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling getBrandVersionList");
      }

      let pathParams = {
        'brand_id': brandId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [BrandVersionList];
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setBrandState operation.
     * @callback module:api/BrandApi~setBrandStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/BrandStateUpdate} brand The updated Brand resource
     * @param {module:api/BrandApi~setBrandStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandState}
     */
    setBrandState(acceptLanguage, id, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setBrandState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setBrandState");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling setBrandState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandState;
      return this.apiClient.callApi(
        '/brands/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateBrand operation.
     * @callback module:api/BrandApi~updateBrandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/BrandUpdate} brand Required properties are: * name  Rich-text properties are: * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/BrandApi~updateBrandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandRead}
     */
    updateBrand(acceptLanguage, id, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateBrand");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateBrand");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling updateBrand");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandRead;
      return this.apiClient.callApi(
        '/brands/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateBrandVersion operation.
     * @callback module:api/BrandApi~updateBrandVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Brand resource version.
     * @param {String} brandId 
     * @param {String} id 
     * @param {module:model/BrandVersionWrite} brand Required properties are: * name  Rich-text properties are: * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/BrandApi~updateBrandVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    updateBrandVersion(brandId, id, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling updateBrandVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateBrandVersion");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling updateBrandVersion");
      }

      let pathParams = {
        'brand_id': brandId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateBrandVersionOptions operation.
     * @callback module:api/BrandApi~updateBrandVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Brand resource version options.
     * @param {String} brandId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject4} opts.brand 
     * @param {module:api/BrandApi~updateBrandVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    updateBrandVersionOptions(brandId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['brand'];
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling updateBrandVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateBrandVersionOptions");
      }

      let pathParams = {
        'brand_id': brandId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
